// 1. 引入 Vue Router
import Vue from 'vue'
import Router from 'vue-router'

import home from '@/views/index'
import {checkSessionApi} from "../api/login";
import store from "../store/store";
import {delCookie, getCookie} from "../util/cookie";
import {Message,MessageBox} from "element-ui";

Vue.use(Router)

// 2. 定义路由
const router = new Router({

    routes: [
        {
            path: '/',
            name: 'home',
            component: home,
            meta: {
                theme: 'dark'
            }
        }
    ]
})

router.beforeEach((to, from, next) => {
    // debugger;
    // 可以在这里验证用户权限
    if (to.meta.auth) {
        checkSessionApi().then(res => {
            if (res.retCode === '0000') {
                if (to.name === 'intellect-chat'){
                    MessageBox('即将上线', '温馨提示');
                    next(false);
                }else {
                    next()
                }
            } else {
                if (getCookie('g_session')){
                    Message.warning('登陆状态已过期');
                }
                store.dispatch('login/showLoginDialog');
                store.dispatch('login/clearUserInfo');
                delCookie('g_session');
                next({
                    path: '/',
                })
            }
        })
    } else {
        next()
    }
})

// 3. 动态添加路由
// 假设你的 views 文件夹下有多个目录，每个目录下都有一个 index.vue 文件
const views = [
    {
        view: 'feature',
        meta: {
            noMenu: true,
            theme: 'dark',
            auth: true
        }
    },
    {
        view: 'intellect-design',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true
        }
    },
    {
        view: 'intellect-computed',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true,
            quickMenu: ['intellect-computed','custom-structure','edit-custom-structure']
        }
    },//intellect-egdiscivil
    {
        view: 'intellect-chat',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true
        }
    },
    {
        view: 'intellect-eqdiscivil',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true
        }
    },
    //views/intellect-eqdiscivil/
    //views/intellect-eqdiscivil/
    {
        view: 'person-space',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true
        }
    },
    {
        view: 'edit-custom-structure',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true,
            quickMenu: ['intellect-computed','custom-structure','edit-custom-structure']
        }
    },
    {
        view: 'custom-structure',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true,
            quickMenu: ['intellect-computed','custom-structure','edit-custom-structure']
        }
    },
    {
        view: 'admin-center',
        meta: {
            noMenu: true,
            theme: 'white',
            auth: true,
        }
    }
]

views.forEach(item => {
    let view = item.view;
    router.addRoute({
        path: `/${view}`,
        name: view,
        component: () => import(`@/views/${view}/index.vue`),
        meta: item.meta || {}
    })
})

// 4. 导出路由实例

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject)
        return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch((err) => err);
};


export default router



// WEBPACK FOOTER //
// ./src/router/index.js